import { useEffect } from "react";

/**
 * Hook to handle anchor scrolling when page loads with a hash in the URL
 * @param {number} delay - Delay in milliseconds before scrolling (default: 100)
 */
export default function useScrollToAnchor(delay = 100) {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      // Small delay to ensure page is fully rendered
      setTimeout(() => {
        const element = document.getElementById(hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, delay);
    }
  }, [delay]);
}
